import React from 'react';
import { GROUP_PLAN_MATRIX } from '../../constants/groupLimits';
import { typography } from '../../design-system/tokens';

function Cell({ value }) {
  if (value === true) {
    return <span className="text-emerald-400 font-black" aria-label="Included">✓</span>;
  }
  if (value === false) {
    return <span className="text-gray-600 font-black" aria-label="Not included">—</span>;
  }
  return <span className="text-gray-300 font-bold text-xs">{value}</span>;
}

export default function GroupPlanMatrix({ compact = false }) {
  return (
    <div className={compact ? '' : 'rounded-xl border border-gray-800/80 bg-black/30 p-3'}>
      {!compact && (
        <p className={`${typography.microWide} text-gray-500 mb-2`}>Free vs Plus — leagues</p>
      )}
      <div className="overflow-x-auto">
        <table className="w-full text-left text-xs">
          <thead>
            <tr className="text-gray-500 uppercase tracking-widest">
              <th className="pb-2 pr-3 font-black">Feature</th>
              <th className="pb-2 pr-3 font-black">Free</th>
              <th className="pb-2 font-black text-violet-300">Plus</th>
            </tr>
          </thead>
          <tbody>
            {GROUP_PLAN_MATRIX.map((row) => (
              <tr key={row.feature} className="border-t border-gray-800/60 text-gray-300">
                <td className="py-2 pr-3 font-medium">{row.feature}</td>
                <td className="py-2 pr-3"><Cell value={row.free} /></td>
                <td className="py-2"><Cell value={row.plus} /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
